import { createAsyncThunk } from '@reduxjs/toolkit';

import { setSingleCampaignData } from 'states/singleCampaign/singleCampaignSlice';
import { getSingleCampaignDetails } from 'api/singleCampaignApi';

// Get Single Campaign Details Action
export const singleCampaignDetails = createAsyncThunk(
    "singleCampaign/getDetails",
    async ({ token, data }, { rejectWithValue, dispatch }) => {
        try {
            const response = await getSingleCampaignDetails(token, data); // Call the API function
            dispatch(setSingleCampaignData(response?.data?.data)); // Dispatch action to set campaign data
            return response; // Return the response on success
        } catch (error) {
            // Handle errors and pass custom error message from backend
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            } else {
                return rejectWithValue(error); // Return the error if no response data
            }
        }
    }
);
